import { useCallback } from "react";

import { getCreateEmployerAccountRedirectLink } from "@js/apps/auth/hooks/onboarding-form/helpers";
import { ModalInstance } from "@js/components/modal";
import { useQueryParams } from "@js/hooks/query-params";
import { LocalStorage } from "@js/services/local-storage";

export const useOnboardingPopup = () => {
  const queryParams = useQueryParams();
  const getReferrer = useCallback(() => {
    return (
      LocalStorage.getItem(LocalStorage.keys.SIGN_UP_REFERRER, () => {
        return queryParams.referrer as string | undefined;
      }) || undefined
    );
  }, [queryParams.referrer]);

  const handleEmployerAccountClick = useCallback(() => {
    window.location.href = getCreateEmployerAccountRedirectLink(getReferrer());
    ModalInstance.close();
  }, [getReferrer]);

  const handlePersonalAccountClick = useCallback(() => {
    ModalInstance.close();
  }, []);

  return { handleEmployerAccountClick, handlePersonalAccountClick };
};
